import React from 'react'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl';
import AllAnnouncementsLogs from '../../../_metronic/partials/widgets/tables/AllAnnouncementsLogs';
const dashboardBreadCrumbs: Array<PageLink> = [
    {
      title: 'Home',
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
    {
      title: 'All Announcements Logs',
      path: '/dashboard',
      isSeparator: false,
      isActive: false,
    },
  ];
function AllAnnouncementDashboardLogs() {
    const intl = useIntl();
  return (
    <div>
         <PageTitle breadcrumbs={dashboardBreadCrumbs}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        </PageTitle>
        <AllAnnouncementsLogs/>
    </div>
  )
}

export default AllAnnouncementDashboardLogs;